import { Component, input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[ziro-license-module-row]',
  templateUrl: './license-module-row.component.html',
  standalone: false,
})
export class LicenseModuleRowComponent {
  readonly moduleEnabled = input<boolean>();
  readonly moduleName = input<string>();
}
